<template>
  <div
    class="flex shrink-0 flex-col justify-between rounded-md bg-white shadow sm:w-96 h-48 px-6 py-5"
  >
    <div class="flex flex-col gap-2">
      <div class="flex w-full items-center gap-2">
        <img
          class="w-10 h-10 relative inline-block rounded-full object-cover"
          :src="tenant.logo_url"
          alt=""
          v-if="tenant.logo_url"
        />
        <div
          v-else
          class="h-10 w-10 flex-shrink-0 rounded-full bg-gray-300 p-2"
        >
          <building-seven class="text-white" />
        </div>

        <h3
          class="text-lg font-medium text-black whitespace-normal line-clamp-2"
        >
          {{ tenant.name }}
        </h3>
      </div>

      <div class="text-sm">
        <div>{{ tenant.address }}</div>
        <div>
          {{ tenant.postal_code }}
          <span v-if="tenant.city && tenant.postal_code">-</span>
          {{ tenant.city }}
        </div>
      </div>
    </div>
    <div class="flex w-full items-center justify-between">
      <div class="isolate flex -space-x-1 overflow-hidden p-0.5 pl-0.5">
        <user-avatar
          v-for="(member, index) in tenantMembers.slice(0, 6)"
          :key="member.id"
          :user="member"
          class="ring-1 ring-brand-900/25 rounded-full relative inline-block"
          :style="{ 'z-index': index * 10 }"
          :withRing="false"
        />
      </div>
      <div class="flex-1 truncate">
        <button
          v-if="subscription === 'Expired Trial'"
          type="button"
          class="float-right inline-flex items-center rounded-sm border border-transparent bg-red-100 px-3 py-2 text-sm font-medium leading-4 text-red-500 shadow-sm focus:outline-none focus:ring-0 focus:ring-offset-0"
        >
          <ExclamationTriangleIcon
            class="-ml-0.5 mr-2 h-4 w-4"
            aria-hidden="true"
          />
          {{ subscription }}
        </button>
        <button
          v-else
          type="button"
          class="float-right inline-flex items-center rounded-sm border border-transparent bg-gray-200 px-3 py-2 text-sm font-medium leading-4 text-brand-900 shadow-sm focus:outline-none focus:ring-0 focus:ring-offset-0"
        >
          <stars-two class="-ml-0.5 mr-2 h-4 w-4" aria-hidden="true" />
          {{ subscription }}
        </button>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed, defineProps } from "vue";
import StarsTwo from "@/Tailwind/Icon/StarsTwo";
import { ExclamationTriangleIcon } from "@heroicons/vue/24/outline";
import UserAvatar from "@/Tailwind/Components/UserAvatar";
import BuildingSeven from "@/Tailwind/Icon/BuildingSeven";

const props = defineProps({
  tenant: { type: Object },
});

const subscription = computed(() => {
  return props.tenant.plan.name;
});

const tenantMembers = computed(() => props.tenant.members);
</script>
